import * as React from 'react';

const Upload16: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M21 15.75C21.4142 15.75 21.75 16.0858 21.75 16.5V19C21.75 20.5188 20.5188 21.75 19 21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V16.5C2.25 16.0858 2.58579 15.75 3 15.75C3.4142 15.75 3.75 16.0858 3.75 16.5V19C3.75 19.6904 4.30965 20.25 5 20.25H19C19.6903 20.25 20.25 19.6903 20.25 19V16.5C20.25 16.0858 20.5858 15.75 21 15.75ZM12 21.75C11.5858 21.75 11.25 21.4142 11.25 21L11.25 8.7314L8.5127 11.2969C8.21051 11.5802 7.73642 11.5649 7.45312 11.2627C7.16983 10.9605 7.18512 10.4864 7.4873 10.2031L11.4873 6.4531C11.7758 6.1827 12.2242 6.1827 12.5127 6.4531L16.5127 10.2031C16.8149 10.4864 16.8302 10.9605 16.5469 11.2627C16.2636 11.5649 15.7895 11.5802 15.4873 11.2969L12.75 8.7314L12.75 21C12.75 21.4142 12.4142 21.75 12 21.75Z'
				fill='#333333'
			/>
		</svg>
	);
};

export default Upload16;
